import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditProgramTimer = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Program Timer'
      fields={fields}
      apiPath={`admin/program_timer_types/${props.params.programTimerTypeId}`}
      successRedirectPath='/write-now/program_timers'
      buildMenuItems={menuItems}
    />
  )
}

export default EditProgramTimer
